import { useEffect, useState } from "react";
import { useLang } from "@/context/LanguageContext";
import LanguageToggle from "@/components/site/LanguageToggle";
import logo from "@/assets/szn-trip.webp";

export default function Header({ onCta, phase }) {
  const { t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const ctaLabel = phase === "booking" ? t.header.ctaBooking : t.header.ctaWaitlist;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-[500] transition-[background-color,box-shadow,padding] duration-300 ${
        scrolled
          ? "bg-[#F6F1E8]/85 py-2 shadow-[0_2px_20px_rgba(20,40,58,0.08)] backdrop-blur-md"
          : "bg-transparent py-3"
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 sm:px-5">
        <a href="#hero" className="flex items-center" data-testid="logo-link" aria-label="SZN TRIP">
          <img src={logo} alt="SZN Trip" className="h-12 w-auto sm:h-16" />
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {t.header.nav.map(([label, href]) => (
            <a
              key={href}
              href={href}
              className="text-sm font-semibold text-[#14283A] transition-colors hover:text-[#EA7A4F]"
            >
              {label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <LanguageToggle />
          <button
            onClick={onCta}
            data-testid="header-cta-button"
            className="grad-bar rounded-full px-4 py-2 text-xs font-bold text-white shadow-md transition-transform duration-200 hover:scale-105 active:scale-95 sm:px-5 sm:py-2.5 sm:text-sm"
          >
            {ctaLabel}
          </button>
        </div>
      </div>
    </header>
  );
}
